import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/goods/shoucang-active.png'
import _imports_1 from '@/assets/image/goods/shoucang.png'
import _imports_2 from '@/assets/image/goods/like-active.png'
import _imports_3 from '@/assets/image/goods/like.png'
import _imports_4 from '@/assets/image/goods/unlike-active.png'
import _imports_5 from '@/assets/image/goods/unlike.png'


const _withScopeId = n => (_pushScopeId("data-v-347568ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "GoodsItemAction" }
const _hoisted_2 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_0
}
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_2,
  title: ""
}
const _hoisted_5 = ["title"]
const _hoisted_6 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: _imports_4
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "flex find-same-wrap" }
const _hoisted_9 = { class: "GoodsItemAction-search-text" }

import memberEventBox from '@/components/common/MemberEventBox.vue'

import { t } from '@/plugins/i18n'
import { productFavorite, productFavoriteCancel, handleProductBehavior } from '@/apis/goods'
import { ElMessage as message } from 'element-plus'
import { useRtfix, useSite } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { confirmLogin, confirmFinishAdd } from '@/util/useConfirm'
import { useStore } from 'vuex'
import { navigateToImageSearch } from '@/util/useSearchByImage'
import { debounce } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  item: {
    type: Object,
    default: null
  },
  // 前端展示场景 1-搜索列表;2-猜你喜欢;3-店铺商品列表;4-商品详情;5-收藏;6-已购买;7-足迹;8-担当推荐;9-系统推荐;10-找相似;11-关联商品;
  showChannel: {
    type: Number,
    default: null
  }
},
  emits: ['unlike', 'cancelCollect'],
  setup(__props, { emit: emits }) {

const props = __props
const route = useRoute()
const router = useRouter()
const store = useStore


const searchSimilar = (item: any) => {
  confirmLogin(() => router.push(useRtfix('list', { query: { productCode: item.productCode } })))
}

const searchSame = async (item: any) => {
  confirmLogin(() => navigateToImageSearch(item.productMainImg, '0'))
}



// 收藏操作
const handleFavorite = debounce(() => {
  confirmLogin(async () => {
    const formData = {
      productCode: props.item.productCode
    }
    if (props.item.favoriteFlag) {
      // 取消收藏
      // 请求前先反馈
      props.item.favoriteFlag = 0
      emits('cancelCollect', formData.productCode)
      await productFavoriteCancel(formData).then(res => {
        if (res.code === '0') {
          // props.item.favoriteFlag = 0
          // emits('cancelCollect', formData.productCode)
        }
      })
    } else {
      // 添加收藏
      // 请求前先反馈
      message.success(t('商品收藏成功'))
      props.item.favoriteFlag = 1
      await productFavorite(formData).then(res => {
        if (res.code === '0') {
          // message.success(t('商品收藏成功'))
          // props.item.favoriteFlag = 1
        }
      })
    }
  })
}, 500)

// 喜欢和不喜欢操作
const handleLike = (behaviorFlag: number) => {
  confirmLogin(async () => {
    const formData: any = {
      behaviorChannel: props.showChannel,
      productCode: props.item.productCode
    }
    if (behaviorFlag === props.item.behaviorFlag) {
      // 如果传入的状态为当前状态，就取消
      formData.behaviorFlag = 0
    } else {
      formData.behaviorFlag = behaviorFlag
    }
    // 请求前先反馈
    props.item.behaviorFlag = formData.behaviorFlag
    if (formData.behaviorFlag === 1) {
      message.success(t('感谢反馈，我们将为你推荐更加准确的商品'))
    } else
    if (formData.behaviorFlag === 2) {
      emits('unlike', formData.productCode)
    }
    await handleProductBehavior(formData).then((res: any) => {
      if (res.code === '0') {
        // props.item.behaviorFlag = formData.behaviorFlag
        // if (formData.behaviorFlag === 1) {
        //   message.success(t('感谢反馈，我们将为你推荐更加准确的商品'))
        // } else
        // if (formData.behaviorFlag === 2) {
        //   emits('unlike', formData.productCode)
        // }
      }
    })
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(memberEventBox, {
      listenVariable: __props.item,
      subscript: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["GoodsItemAction-top", !__props.item.productTag && !__props.item.countryProductTag ? (__props.item.behaviorFlag === 1 || __props.item.behaviorFlag === 2 ? 'selected' : 'default') : ''])
        }, [
          _createElementVNode("div", {
            class: "GoodsItemAction-top-icon tstnc",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(handleFavorite) && _unref(handleFavorite)(...args)), ["prevent","stop"]))
          }, [
            (__props.item.favoriteFlag === 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_2))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  referrerPolicy: "no-referrer",
                  src: _imports_1,
                  title: _unref(t)('收藏商品')
                }, null, 8, _hoisted_3))
          ]),
          (!__props.item.productTag && !__props.item.countryProductTag)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _withDirectives(_createElementVNode("div", {
                  class: "GoodsItemAction-top-icon tstnc",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleLike(1)), ["prevent","stop"]))
                }, [
                  (__props.item.behaviorFlag === 1)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        referrerPolicy: "no-referrer",
                        src: _imports_3,
                        title: _unref(t)('多为我推荐此类型商品')
                      }, null, 8, _hoisted_5))
                ], 512), [
                  [_vShow, __props.item.behaviorFlag !== 2]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: "GoodsItemAction-top-icon tstnc nolike",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (handleLike(2)), ["prevent","stop"]))
                }, [
                  (__props.item.behaviorFlag === 2)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        referrerPolicy: "no-referrer",
                        src: _imports_5,
                        title: _unref(t)('不再推荐此商品')
                      }, null, 8, _hoisted_7))
                ], 512), [
                  [_vShow, __props.item.behaviorFlag !== 1]
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["listenVariable"]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex-cen-ter fx-1 GoodsItemAction-findSame", _unref(useSite)()]),
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (searchSame(__props.item)), ["prevent","stop"]))
      }, _toDisplayString(_unref(t)('找同款')), 3),
      _createElementVNode("div", {
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (searchSimilar(__props.item)), ["prevent","stop"])),
        class: "fx-1"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["GoodsItemAction-search", _unref(useSite)()])
        }, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('找相似1')), 1)
        ], 2)
      ])
    ])
  ]))
}
}

})